/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox } from "../../util/Functions";
import { Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, Grid, TextField, MenuItem } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const StpRegister = (props) => {
  const history = useHistory();
  const [zPos, setZPos] = useState(45)
  const [spaceClabe, setSpaceClabe] = useState("");
  const [content, setContent] = useState(null);
  const [data, setData] = useState([
    {key: "gname", label: "Nombre"},
    {key: "email", label: "Email"},
    {key: "phone", label: "Teléfono"},
    {key: "populationid", label: "CURP"},
  ]);

  useEffect(() => {
    if (props.data.spaces) {
      setSpaceClabe(props.data.spaces[0].clabe);
    }
    if(props.data.content) {
      setContent(props.data.content)
    }
  }, []);

  const onSelectSpace = (event: React.ChangeEvent<{ value: unknown }>) => {
    let value = event.target.value as string;
    setSpaceClabe(value);
  };

  const onSubmit = async () => {
    props.changeLoader(true);
    setZPos(-1)
    let data = {
      primer_apellido: content.lname,
      segundo_apellido: content.slname,
      nombres: content.gname,
      clabe: spaceClabe,
      email: content.email,
      phone: content.phone,
    };
    if(content.populationid){
      data["curp"] = content.populationid
    }
    if(!content.populationid && content.taxid){
      data["rfc"] = content.taxid
    }

    let request = await API.service( "stpRegister", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status == 200 && request.data.data.response == "OK") {
      props.changeAlert(true, "success", "STP registrado con éxito");
      closelightbox();
      props.changeLoader(false);
    }
    props.changeLoader(false);
    setZPos(45)
  };

  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(false)}>
        <DialogTitle>
          Alta STP
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>
        
        <DialogContent sx={{paddingBottom: "0px" }}>
          <Grid container spacing={2} sx={{paddingTop: "10px"}}>
            {data.map((item, index) => {
              return (
              <Grid container spacing={2} key={index}  sx={{marginLeft: "0px", marginTop: "-9px"}}>
                <Grid item xs={4} sx={{color: "#969BA0"}}>{item.label}</Grid>
                <Grid item xs={8} >{item.key === "gname" ? <b>{props.data.content.gname} {props.data.content.lname}{" "}{props.data.content.slname}</b> : props.data.content[item.key]}</Grid>
              </Grid>
            )})}

            <Grid item xs={6} sx={{paddingTop: "35px !important"}}>
              <TextField label="CLABE" value={spaceClabe} onChange={onSelectSpace} select	size="small" fullWidth >
                <MenuItem value="-1" >Selecione</MenuItem>
                {props.data?.spaces?.map((item, index) => (
                  <MenuItem key={`space-${index}`} value={item.clabe}>{item.clabe}</MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>					
          <Button variant="contained" onClick={onSubmit} >Aceptar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog>
  );
};

export default StpRegister;
